import { createFormAction } from 'redux-form-saga';
import * as types from './types';
import { home } from 'app/routes';

export const authenticationSucceeded = (response) => ({
  type: types.AUTHENTICATION_SUCCEEDED,
  payload: response
});

export const authenticationFailed = (err) => ({
  type: types.AUTHENTICATION_FAILED,
  payload: err
})

export const authenticate = (redirectTo = home()) => ({
  type: types.AUTHENTICATE,
  payload: { redirectTo },
});

export const resetPassword = createFormAction(types.RESET_PASSWORD);
export const requestResetCode = createFormAction(types.REQUEST_RESET_CODE);

export const resetCodeSent = (resetEmail) => ({
  type: types.RESET_CODE_SENT,
  payload: { resetEmail }
});

export const showVerificationCode = (timerTime) => ({
  type: types.SHOW_VERICATION_CODE,
  payload: { timerTime },
});

export const setMdnValidCode = () => ({
  type: types.SET_MDN_VALID,
});

export const resetMdnValidCode = () => ({
  type: types.RESET_MDN_VALID,
});

export const logout = () => ({
  type: types.LOGOUT,
});

export const logoutPending = () => ({
  type: types.LOGOUT_PENDING,
});

export const logoutSucceeded = () => ({
  type: types.LOGOUT_SUCCEEDED
});

export const logoutFailed = () => ({
  type: types.LOGOUT_FAILED
});

export const setRedirect = (redirectTo) => ({
  type: types.SET_REDIRECT,
  payload: { redirectTo },
});

export const createAddress = (payload) => ({
  type: types.CREATE_ADDRESS,
  payload,
});

export const createAddressPending = (payload) => ({
  type: types.CREATE_ADDRESS_PENDING,
  payload,
});

export const createAddressSucceeded = (response) => ({
  type: types.CREATE_ADDRESS_SUCCEEDED,
  payload: response.data,
});

export const createAddressFailed = () => ({
  type: types.CREATE_ADDRESS_FAIlED
});

export const updateAddress = (payload) => ({
  type: types.UPDATE_ADDRESS,
  payload,
});

export const updateAddressPending = (payload) => ({
  type: types.UPDATE_ADDRESS_PENDING,
  payload,
});

export const updateAddressSucceeded = (response) => ({
  type: types.UPDATE_ADDRESS_SUCCEEDED,
  payload: response.data,
});

export const updateAddressFailed = () => ({
  type: types.UPDATE_ADDRESS_FAIlED
});

export const resetStore = () => ({
  type: types.RESET_STORE
});
